import React from 'react'
import FacebookLogin from 'react-facebook-login';
import { SERVER_URL } from '../../../ServerUrl';
import axios from 'axios';
import { Link, useHistory } from "react-router-dom";
import Swal from 'sweetalert2';
import { SetUserdataOperator } from '../../../Redux/userReducer';
import { useSelector, useDispatch } from "react-redux";

const FacebookLoginUser = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const responseFacebook = async (response) => {
        // Check if the response is valid
        if (!response || response.status === 'unknown') {
            console.error("Failed to login with Facebook. Please try again.");
            // alert("Facebook login failed. Please try again or check your connection.");
            return;
        }
        console.log(response, "faceresponse");

        try {
            const resp = await axios.post(
                `${SERVER_URL}/auth/facebook-login`,
                {
                    name: response?.name,
                    email: response?.email,
                    id: response?.id,
                }
            );

            console.log(resp, "123data");
            Swal.fire({
                icon: "success",
                text: "You have successfully signed in",
            });
            dispatch(SetUserdataOperator(resp?.data));
            history.push("/")
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "error",
                text: error?.response?.data?.message,
            });
        }
    };
    return (
        <>
            <FacebookLogin
                appId="1059728785923994"
                autoLoad={false}
                fields="name,email,picture"
                callback={responseFacebook}
                textButton="Sign In with Facebook"
                icon="fa-facebook"
                className="faceLogBtn"
            />
        </>
    )
}

export default FacebookLoginUser
